//Core Environment
export const BACKEND_URL = "https://seismic-app-server-uat-gjdzdrewfmhscugq.westus-01.azurewebsites.net/"
// export const BACKEND_URL = "http://localhost:8080"
export const DOCTOR_PORTAL_URL = "https://care-patient.seismicconnect.com/"
export const SOS_URL = "https://seismicdockerbackend-uat-gyauhkasbcdzenbt.westus-01.azurewebsites.net/"
export const STREAM_API_KEY = "23dnbb2d3q8q"
//export const REDIRECT_URI = "http://localhost:3000/"
export const REDIRECT_URI = "https://care.seismicconnect.com"
export const CHATBOT_URL = "https://sesmic-stg.azurewebsites.net/";
export const CIAM_AUTH_URL = "https://leapgenaiexternal.ciamlogin.com/526922da-32fc-472e-a268-3875f1d50517/oauth2/v2.0/authorize"
export const CIAM_CLIENT_ID = "e8f47d33-02b8-4467-b0d8-8f705b07a463"
export const CIAM_REDIRECT_URI = "https://registration.seismicconnect.com/standalone/registration"
//export const CIAM_REDIRECT_URI = "http://localhost:3000/standalone/registration"


//Test Environment
//export const BACKEND_URL = "https://seismic-app-server-test-gqd5bjfmgabwa9he.centralus-01.azurewebsites.net/"
// export const BACKEND_URL = "http://localhost:8080"
//export const DOCTOR_PORTAL_URL = "https://patient-test.seismicconnect.com/"
//export const SOS_URL = "https://seismicdockerbackend-test-e0ducsgtggh7ftat.centralus-01.azurewebsites.net/"
//export const STREAM_API_KEY = "qb4swzqqxr76"
// export const REDIRECT_URI = "http://localhost:3000/"
//export const REDIRECT_URI = "https://test.seismicconnect.com/"
//export const CHATBOT_URL = "https://sesmic-test.azurewebsites.net/";

//Dev Environment
//export const BACKEND_URL = "https://seismic-backend-04272025-bjbxatgnadguabg9.centralus-01.azurewebsites.net/"
// export const BACKEND_URL = "http://localhost:8080"
//export const DOCTOR_PORTAL_URL = "https://patient-dev.seismicconnect.com/"
//export const SOS_URL = "https://seismicdockerbackend-test-e0ducsgtggh7ftat.centralus-01.azurewebsites.net/"
//export const STREAM_API_KEY = "72499ykcfb3z"
// export const REDIRECT_URI = "http://localhost:3000/"
//export const REDIRECT_URI = "https://dev.seismicconnect.com/"
//export const CHATBOT_URL = "https://chat-strlit-gva3h7ekahgdctgk.centralus-01.azurewebsites.net"
//export const CIAM_AUTH_URL = "https://leapgenaiexternal.ciamlogin.com/526922da-32fc-472e-a268-3875f1d50517/oauth2/v2.0/authorize"
//export const CIAM_CLIENT_ID = "e8f47d33-02b8-4467-b0d8-8f705b07a463"
//export const CIAM_REDIRECT_URI = "https://registration.seismicconnect.com/standalone/registration"
//export const CIAM_REDIRECT_URI = "http://localhost:3001/standalone/registration"